import React, { useEffect, useState } from "react";
import {
  
  CModal,
  CModalBody,
} from "@coreui/react";
import { useDispatch } from "react-redux";
import crossButton from "../../../components/assets/image/crossButton.svg";
import placeholderImage from "../../../components/assets/image/placeholder.png";
import "../../../components/common/styles/changePassword.css";
import "../../../components/common/styles/createAdmin.css";
import { addCategoryRequest } from "../redux/categoryDispatcher";
import { hideAddCategoryModal, showAddCategoryModal } from "../redux/categoryModalDispatcher";
import { imageBaseUrls } from "../../../constant/ApiUrls";

const AddCategory = ({
  parentId = 0,
  buttonLabel = "Add Category",
  editMode = false,
  categoryData = {},
}) => {
  // console.log("parent id", parentId);
  const dispatch = useDispatch();
  // const isModalVisible = useSelector(
  //   (state) => state.categoryModalReducer.isModalVisible
  // );
  const [isModalVisible, setIsModalVisible] = useState(false); // Local State

  const [categoryName, setCategoryName] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState(null);
  const [uploadImage, setUploadImage] = useState(null);
  const [isVehicle, setIsVehicle] = useState(false);
  const [showFinance, setShowFinance] = useState(false);


  const [make, setMake] = useState(true);
  const [model, setModel] = useState(true);
  const [bodyType, setBodyType] = useState(true);
  const [fuelType, setFuelType] = useState(true);
  const [colour, setColour] = useState(true);
  const [year, setYear] = useState(true);
  const [transmission, setTransmission] = useState(true);
  const [engineSize, setEngineSize] = useState(true);
  const [gearbox, setGearbox] = useState(false);
  const [variant, setVariant] = useState(false);
  const [engineCc, setEngineCc] = useState(false);
  const [batteryRange, setBatteryRange] = useState(false);
  const [driveType, setDriveType] = useState(false);
  const [wheelBase, setWheelBase] = useState(false);
  const [fuelConsumption, setFuelConsumption] = useState(false);
  const [vat, setVat] = useState(false);

  const [seats, setSeats] = useState(false);
  const [doors, setDoors] = useState(false);
  const [trim, setTrim] = useState(false);
  const [co2Emission, setEmission] = useState(false);
  const [bootSpace, setBootSpace] = useState(false);
  const [keywordSearch, setKeywordSearch] = useState(false);




    const [taxFee, setTaxFee] = useState(false);
  const [taxStatus, setTaxStatus] = useState(false);
  const [taxExpiry, setTaxExpiry] = useState(false);
  const [texDuration, setTaxDuration] = useState(false);
  const [co, setCo] = useState(false);



  useEffect(() => {
    if (editMode && categoryData) {
      setCategoryName(categoryData.name || "");
      setDescription(categoryData.description || "");
      setIsVehicle(categoryData.is_vehicle === 0 ? false : true);
      setShowFinance(categoryData.show_finance === 0 ? false : true);
      
      console.log("cjkchjschdkshdjskh::::::", categoryData);
      if (categoryData.image) {
        setImage(imageBaseUrls(categoryData.image));
      }




      if (categoryData.vehicle_data ) {
        console.log("LOG ATATA::",categoryData.vehicle_data);
        var data=JSON.parse(categoryData.vehicle_data);
        setMake(data.make ===0?false:true);
        setModel(data.model ===0?false :true);
        setBodyType(data.body_type ===0?false:true);
        setFuelType(data.fuel_type ===0?false:true);
        setColour(data.colour ===0?false:true);
        setYear(data.year ===0?false:true);
        setTransmission(data.transmission ===0?false:true);
        setEngineSize(data.engine_size ===0?false:true);
        setGearbox(data.gearbox ===0?false:true);
        setVariant(data.variant ===0?false:true);
        setEngineCc(data.engine_cc ===0?false:true);
        setBatteryRange(data.battery_range ===0?false:true);
        setDriveType(data.drive_type ===0?false:true);
        setWheelBase(data.wheel_base ===0?false:true);
        setFuelConsumption(data.fuel_consumption ===0?false:true);
        setVat(data.vat ===0?false:true);

        setSeats(data.number_of_seats ===0?false:true);
        setDoors(data.number_of_doors ===0?false:true);
        setTrim(data.trim ===0?false:true);
        setEmission(data.co2 ===0?false:true);
        setBootSpace(data.boot_space ===0?false:true);
        setKeywordSearch(data.keyword_search ===0?false:true);

        setTaxFee(data.tax_fee===0?false:true);
        setTaxStatus(data.tax_status===0?false:true);
        setTaxExpiry(data.nct_expiry===0?false:true);
        setTaxDuration(data.tax_duration===0?false:true);
        setCo(data.co===0?false:true);

      }

    }
  }, [editMode, categoryData]);

  const resetForm = () => {
    setCategoryName("");
    setDescription("");
    setImage(null);
    setUploadImage(null);
    setIsVehicle(false);
    setShowFinance(false);
  };
  // Handle Image Upload
  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const validTypes = ["image/jpeg", "image/png", "image/jpg"];
      if (validTypes.includes(file.type)) {
        const imageUrl = URL.createObjectURL(file);
        setImage(imageUrl);
        setUploadImage(file);
      } else {
        alert("Please select a valid image file (JPEG, PNG, JPG)");
      }
    }
  };

  // Handle Add Category Submission
  const handleAddCategory = () => {
    if (categoryName.trim() === "") {
      alert("Category name is required");
      return;
    }
    // if (!uploadImage && editMode==false) {
    //   alert("Please upload an image for the category.");
    //   return;
    // }

    var data = {

      "name": categoryName,
      "parent_id": "0",
      "description": description,
      'is_vehicle': isVehicle ? 1 : 0,
      'show_finance':showFinance?1:0,

    };


    if (isVehicle) {
      var vehicleData = {};
      vehicleData['make'] = make ? 1 : 0;
      vehicleData['model'] = model ? 1 : 0;
      vehicleData['body_type'] = bodyType ? 1 : 0;
      vehicleData['fuel_type'] = fuelType ? 1 : 0;
      vehicleData['colour'] = colour ? 1 : 0;
      vehicleData['year'] = year ? 1 : 0;
      vehicleData['transmission'] = transmission ? 1 : 0;
      vehicleData['engine_size'] = engineSize ? 1 : 0;
      vehicleData['gearbox'] = gearbox ? 1 : 0;
      vehicleData['variant'] = variant ? 1 : 0;
      vehicleData['engine_cc'] = engineCc ? 1 : 0;
      vehicleData['battery_range'] = batteryRange ? 1 : 0;
      vehicleData['drive_type'] = driveType ? 1 : 0;
      vehicleData['wheel_base'] = wheelBase ? 1 : 0;
      vehicleData['fuel_consumption'] = fuelConsumption ? 1 : 0;
      vehicleData['vat'] = vat ? 1 : 0;
      vehicleData['number_of_seats'] = seats ? 1 : 0;
      vehicleData['number_of_doors'] = doors ? 1 : 0;
      vehicleData['trim'] = trim ? 1 : 0;
      vehicleData['co2'] = co2Emission ? 1 : 0;
      vehicleData['boot_space'] = bootSpace ? 1 : 0;
      vehicleData['keyword_search'] = keywordSearch ? 1 : 0;

      vehicleData['tax_fee'] = taxFee ? 1 : 0;
      vehicleData['tax_status'] = taxStatus ? 1 : 0;
      vehicleData['nct_expiry'] = taxExpiry ? 1 : 0;
      vehicleData['tax_duration'] = texDuration ? 1 : 0;
      vehicleData['co'] = co ? 1 : 0;



          


      data['vehicle_data'] = JSON.stringify(vehicleData);

    }


    if (parentId !== 0) {
      data['parent_id'] = parentId;
    }
    if (image) {
      data.image = uploadImage;
    }
    if (editMode) {
      data.id = categoryData.id;
    }
    dispatch(addCategoryRequest(data));
    setCategoryName("");
    setDescription("");
    setImage(null);
    setIsModalVisible(false);
    setUploadImage(null);
    dispatch(hideAddCategoryModal());
  };

  return (
    <div>
      {/* Button to Open Modal */}
      <button
        onClick={() => {
          if (!editMode) {
            resetForm(); // Reset the form if adding
          }
          setIsModalVisible(true)
          dispatch(showAddCategoryModal())

        }}
        style={{
          backgroundColor: editMode === true ? "#1b87f4" : "rgb(0 0 0)",
          color: "white",
          border: "none",
          cursor: "pointer",
          borderRadius: "4px",
          fontSize: editMode === true ? "10px" : "14px",
          minWidth: "60px",
          // width: "100%",
          height: editMode === true ? "24px" : "30px",  // Increased height
          padding: editMode === true ? "2px 5px" : "4px 10px", // Added padding
          display: "flex",
          alignItems: "center",
          // alignSelf:"end",
          justifyContent: "center",
        }}
      >{buttonLabel}</button>
      {/* <CButton
        className="personal-setting-button button"
        onClick={() => dispatch(showAddCategoryModal())}
      >
        Add Category
      </CButton> */}

      {/* Modal */}
      <CModal
        alignment="center"
        visible={isModalVisible}
        onClose={() => setIsModalVisible(false)}
        className="attributemodal"

      >
        <CModalBody className="main-container createAdmin" >
          <div className="main-container createAdmin">
            {/* Close Button */}
            <div className="cross-btn-div d-flex">
              <img
                onClick={() => setIsModalVisible(false)}
                src={crossButton}
                alt="close"
                className="cross-button"
              />
            </div>

            <form onSubmit={(e) => e.preventDefault()} className="login-form">
              <div className="mb-4">
                <h4
                  className="h4 fw-bold"
                  style={{ color: "#007bff", textAlign: "center" }}
                >
                  <b>{editMode === true ? (parentId === 0 ? "Edit Category" : "Edit Sub Category") : (parentId === 0 ? "Add New Category" : "Add New Sub Category")}</b>
                </h4>
              </div>

              {/* Image Upload Section */}
              <div className="mb-3 input-login-box">
                <div className="form-row d-flex justify-content-center mt-2">
                  <input
                    type="file"
                    accept="image/*"
                    id="categoryImageUpload"
                    style={{ display: "none" }}
                    onChange={handleImageChange}
                  />
                  <img
                    style={{ height: "120px", width: "120px", borderRadius: "10px", objectFit: "cover" }}
                    onClick={() =>
                      document.getElementById("categoryImageUpload").click()
                    }
                    src={image || placeholderImage}
                    alt="Category Preview"

                  />
                </div>
              </div>

              {/* Category Name Input */}
              <div className="mb-3 input-login-box">
                <input
                  value={categoryName}
                  onChange={(e) => setCategoryName(e.target.value)}
                  name="name"
                  type="text"
                  className="form-control login-input"
                  placeholder="Enter category name"
                />
              </div>

              {/* Description Input */}
              <div className="mb-3 input-login-box">
                <textarea
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  name="description"
                  className="form-control login-input"
                  placeholder="Enter category description"
                  rows="3"
                />
              </div>
                {
                  parentId !== 0 ? <div className="mb-3 form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="recommendedCheck"
                    checked={showFinance}
                    onChange={() => setShowFinance(!showFinance)}
                  />
                  <label className="form-check-label" htmlFor="recommendedCheck">
                    Show Finance Button
                  </label>
                </div> : <div></div>
              }
              {
                parentId !== 0 ? <div className="mb-3 form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="recommendedCheck"
                    checked={isVehicle}
                    onChange={() => setIsVehicle(!isVehicle)}
                  />
                  <label className="form-check-label" htmlFor="recommendedCheck">
                    Is Vehicle ?
                  </label>
                </div> : <div></div>
              }





              {
                isVehicle === true ? <div>
                  <div className="d-flex mb-3" >
                    <div className="form-check me-3" style={{ flex: 1 }}>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="makeCheck"
                        checked={make}
                        onChange={() => setMake(!make)}
                      />
                      <label className="form-check-label ms-2" htmlFor="makeCheck">
                        Make
                      </label>
                    </div>

                    <div className="form-check-label ms-2" style={{ flex: 1 }}>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="modelCheck"
                        checked={model}
                        onChange={() => setModel(!model)}
                        style={{ verticalAlign: 'middle' }}
                      />
                      <label className="form-check-label ms-2" htmlFor="modelCheck">
                        Model
                      </label>
                    </div>

                  </div>


                  <div className="d-flex mb-3" >
                    <div className="form-check me-3" style={{ flex: 1 }}>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="bodyType"
                        checked={bodyType}
                        onChange={() => setBodyType(!bodyType)}
                      />
                      <label className="form-check-label ms-2" htmlFor="bodyType">
                        Body Type
                      </label>
                    </div>

                    <div className="form-check-label ms-2" style={{ flex: 1 }}>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="fuelType"
                        checked={fuelType}
                        onChange={() => setFuelType(!fuelType)}
                        style={{ verticalAlign: 'middle' }}
                      />
                      <label className="form-check-label ms-2" htmlFor="fuelType">
                        Fuel Type
                      </label>
                    </div>

                  </div>


                  <div className="d-flex mb-3" >
                    <div className="form-check me-3" style={{ flex: 1 }}>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="colour"
                        checked={colour}
                        onChange={() => setColour(!colour)}
                      />
                      <label className="form-check-label ms-2" htmlFor="colour">
                        Colour
                      </label>
                    </div>

                    <div className="form-check-label ms-2" style={{ flex: 1 }}>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="year"
                        checked={year}
                        onChange={() => setYear(!year)}
                        style={{ verticalAlign: 'middle' }}
                      />
                      <label className="form-check-label ms-2" htmlFor="year">
                        Year
                      </label>
                    </div>

                  </div>



                  <div className="d-flex mb-3" >
                    <div className="form-check me-3" style={{ flex: 1 }}>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="transmission"
                        checked={transmission}
                        onChange={() => setTransmission(!transmission)}
                      />
                      <label className="form-check-label ms-2" htmlFor="transmission">
                        Transmission
                      </label>
                    </div>

                    <div className="form-check-label ms-2" style={{ flex: 1 }}>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="engineSize"
                        checked={engineSize}
                        onChange={() => setEngineSize(!engineSize)}
                        style={{ verticalAlign: 'middle' }}
                      />
                      <label className="form-check-label ms-2" htmlFor="engineSize">
                        Engine Size
                      </label>
                    </div>

                  </div>



                  <div className="d-flex mb-3" >
                    <div className="form-check me-3" style={{ flex: 1 }}>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="gearbox"
                        checked={gearbox}
                        onChange={() => setGearbox(!gearbox)}
                      />
                      <label className="form-check-label ms-2" htmlFor="gearbox">
                        Gearbox
                      </label>
                    </div>

                    <div className="form-check-label ms-2" style={{ flex: 1 }}>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="variant"
                        checked={variant}
                        onChange={() => setVariant(!variant)}
                        style={{ verticalAlign: 'middle' }}
                      />
                      <label className="form-check-label ms-2" htmlFor="variant">
                        Variant
                      </label>
                    </div>

                  </div>





                  <div className="d-flex mb-3" >

                         <div className="form-check me-3" style={{ flex: 1 }}>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="co2Emission"
                        checked={co2Emission}
                        onChange={() => setEmission(!co2Emission)}
                      />
                      <label className="form-check-label ms-2" htmlFor="co2Emission">
                        CO2 Emission
                      </label>
                    </div>

                    <div className="form-check-label ms-2" style={{ flex: 1 }}>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="co"
                        checked={co}
                        onChange={() => setCo(!co)}
                        style={{ verticalAlign: 'middle' }}
                      />
                      <label className="form-check-label ms-2" htmlFor="co">
                        CO
                      </label>
                    </div>

                  </div>




    {/*
  const [taxExpiry, setTaxExpiry] = useState(false);
  const [texDuration, setTaxDuration] = useState(false); */}


  <div className="d-flex mb-3" >
                    <div className="form-check me-3" style={{ flex: 1 }}>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="taxFee"
                        checked={taxFee}
                        onChange={() => setTaxFee(!taxFee)}
                      />
                      <label className="form-check-label ms-2" htmlFor="taxFee">
                        Tax Fee
                      </label>
                    </div>

                    <div className="form-check-label ms-2" style={{ flex: 1 }}>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="taxStatus"
                        checked={taxStatus}
                        onChange={() => setTaxStatus(!taxStatus)}
                        style={{ verticalAlign: 'middle' }}
                      />
                      <label className="form-check-label ms-2" htmlFor="taxStatus">
                        Tax Status
                      </label>
                    </div>

                  </div>





 <div className="d-flex mb-3" >
                    <div className="form-check me-3" style={{ flex: 1 }}>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="taxExpiry"
                        checked={taxExpiry}
                        onChange={() => setTaxExpiry(!taxExpiry)}
                      />
                      <label className="form-check-label ms-2" htmlFor="taxExpiry">
                        Tax Expiry
                      </label>
                    </div>

                    <div className="form-check-label ms-2" style={{ flex: 1 }}>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="texDuration"
                        checked={texDuration}
                        onChange={() => setTaxDuration(!texDuration)}
                        style={{ verticalAlign: 'middle' }}
                      />
                      <label className="form-check-label ms-2" htmlFor="texDuration">
                        Tax Duration
                      </label>
                    </div>

                  </div>






















                  



                  <div className="d-flex mb-3" >
                    <div className="form-check me-3" style={{ flex: 1 }}>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="driveType"
                        checked={driveType}
                        onChange={() => setDriveType(!driveType)}
                      />
                      <label className="form-check-label ms-2" htmlFor="driveType">
                        Drive Type
                      </label>
                    </div>

                    <div className="form-check-label ms-2" style={{ flex: 1 }}>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="wheelBase"
                        checked={wheelBase}
                        onChange={() => setWheelBase(!wheelBase)}
                        style={{ verticalAlign: 'middle' }}
                      />
                      <label className="form-check-label ms-2" htmlFor="wheelBase">
                        Wheel Base
                      </label>
                    </div>

                  </div>




                  <div className="d-flex mb-3" >
                    <div className="form-check me-3" style={{ flex: 1 }}>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="fuelConsumption"
                        checked={fuelConsumption}
                        onChange={() => setFuelConsumption(!fuelConsumption)}
                      />
                      <label className="form-check-label ms-2" htmlFor="fuelConsumption">
                        Fuel Consumption
                      </label>
                    </div>

                    <div className="form-check-label ms-2" style={{ flex: 1 }}>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="seats"
                        checked={seats}
                        onChange={() => setSeats(!seats)}
                        style={{ verticalAlign: 'middle' }}
                      />
                      <label className="form-check-label ms-2" htmlFor="seats">
                        Seats
                      </label>
                    </div>

                  </div>



                  <div className="d-flex mb-3" >
                    <div className="form-check me-3" style={{ flex: 1 }}>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="doors"
                        checked={doors}
                        onChange={() => setDoors(!doors)}
                      />
                      <label className="form-check-label ms-2" htmlFor="doors">
                        Doors
                      </label>
                    </div>

                    <div className="form-check-label ms-2" style={{ flex: 1 }}>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="trim"
                        checked={trim}
                        onChange={() => setTrim(!trim)}
                        style={{ verticalAlign: 'middle' }}
                      />
                      <label className="form-check-label ms-2" htmlFor="trim">
                        Trim
                      </label>
                    </div>

                  </div>



                  <div className="d-flex mb-3" >
                     <div className="form-check me-3" style={{ flex: 1 }}>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="keywordSearch"
                        checked={keywordSearch}
                        onChange={() => setKeywordSearch(!keywordSearch)}
                      />
                      <label className="form-check-label ms-2" htmlFor="keywordSearch">
                        Keyword Search
                      </label>
                    </div>

                    <div className="form-check-label ms-2" style={{ flex: 1 }}>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="bootSpace"
                        checked={bootSpace}
                        onChange={() => setBootSpace(!bootSpace)}
                        style={{ verticalAlign: 'middle' }}
                      />
                      <label className="form-check-label ms-2" htmlFor="bootSpace">
                        Boot Space
                      </label>
                    </div>

                  </div>

                  <div className="d-flex mb-3" >
                   


                    <div className="form-check me-3" style={{ flex: 1 }}>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="vat"
                        checked={vat}
                        onChange={() => setVat(!vat)}
                      />
                      <label className="form-check-label ms-2" htmlFor="vat">
                        Vat
                      </label>
                    </div>


                       <div className="form-check-label ms-2" style={{ flex: 1 }}>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="batteryRange"
                        checked={batteryRange}
                        onChange={() => setBatteryRange(!batteryRange)}
                        style={{ verticalAlign: 'middle' }}
                      />
                      <label className="form-check-label ms-2" htmlFor="batteryRange">
                        Battery Range
                      </label>
                    </div>





                  </div>




                </div> : <div></div>
              }



              {/* Submit Button */}
              <button
                className="w-100 btn btn-md btn-warning fw-bold text-light button-color"
                type="button"
                onClick={handleAddCategory}
              >
                {editMode ? "Update" : "Submit"}
              </button>
            </form>
          </div>
        </CModalBody>
      </CModal>
    </div>
  );
};

export default AddCategory;
